import {DynField} from '../dyn-field';
import {DynForm} from '../dyn-form';

export class DynSubformField
    extends DynField {

    private form: DynForm;

    constructor() {
        super(null, 'subform');
    }

    getForm(): DynForm {
        return this.form;
    }

    setForm(value: DynForm) {
        this.form = value;
    }
}



// WEBPACK FOOTER //
// ./src/app/forms/domain/meta/fields/dyn-subform-field.ts